export enum CbhFeatureFlag {
  ATTENDANCE_SCORE_POLICY_LINKS = "attendance-score-policy-links",
  AUTO_VERIFICATION_DOCUMENT_CLEANUP_ENABLED = "auto-id-deletes-abandoned-documents",
  CAMERA_IMAGE_QUALITY = "camera-image-quality-config",
  CAMERA_IMAGE_SIZE = "camera-image-size-config",
  CONVERT_TO_NONIP_AFTER_X_MINUTES = "convert-to-nonIP-after-x-minutes",
  DOCUMENT_VERIFICATION_PROCESS = "document-verification-process",
  ENABLE_CHECKR_PILL_STATUS = "enable-checkr-pill-status",
  ENABLE_GEOLOCATION_TRACKING_FOR_SHIFTS = "enable-geolocation-tracking-for-shifts",
  ENABLE_LATE_FOR_SHIFT = "enable-late-for-shift",
  ENABLE_PA_NOTIFICATION_PREFERENCE = "enable-pa-notification-preference",
  ENABLE_REMAINING_SHIFT_DATA_IN_A_SLOT = "enable-remaining-shift-data-in-a-slot",
  ENABLE_TAG_LOCATION_POPUP = "enable-tag-location-modal",
  FACILITY_TYPE_SHIFT_ICONS = "facility-type-shift-icons-1",
  FORCE_UPDATE = "force-update",
  HCP_APP_RATING_PROMPT_INTERVAL = "hcp-app-rating-prompt-interval",
  HCP_LICENSE_DEFAULT_STATUS = "hcp-license-default-status",
  HCP_LICENSE_FIELDS_REQUIREMENTS = "hcp-license-field-requirements",
  NLC_STATES = "nlc-states",
  ONBOARDING_STRIPE_SETUP_UNSKIPPABLE = "stripe-setup-unskippable",
  PERSONAL_ID_SUBTYPES = "personal-id-subtypes",

  RATE_NEGOTIATION_ACTIVATION = "rate-negotiation-activation",
  RATE_NEGOTIATION_LEAD_TIME = "rate-negotiation-lead-time",
  RATE_NEGOTIATION_LIMITS = "rate-negotiation-limits",
  READS_FILE_STORAGE_MOBILE = "reads-file-storage-mobile",
  SENDBIRD_CONCURRENT_CONNECTION_OPTIMISATION = "send-bird-concurrent-connection-optimisation",
  SENT_HOME_REQUEST_CONFIG = "sent-home-request-config",
  SHIFTS_SORT_KEY_TIMESLOT = "shifts-sort-key-timeslot",
  SHOW_CANCELLATION_PAYOUT = "show-cancellation-payout",
  SUPPORT_LINKS = "support-links",
  TIMESHEETS_V2_NON_IP = "timesheets-v2-non-IP",
  URGENT_SHIFTS = "urgent-shifts",
  URGENT_SHIFTS_CONFIG = "urgent-shifts-config",
  USE_ORIGINALAMOUNT_FIELD_NON_IP = "use-originalamount-field-non-ip",
  WORK_WITH_FRIENDS_BONUSES = "work-with-friends-bonuses",
  OPEN_SHIFT_CARD_AGENT_REQ = "open-shift-card-agent-req",
  SEND_FCF_TO_URGENT_SHIFTS_FLOW = "send-fcf-to-urgent-shifts-flow",
  SIGNUP_BASED_REFERRAL = "signup-based-referral-bonus",
  ENABLE_REFERRAL_SIGNUP_SCREEN = "enable-referral-signup-screen",
  URGENT_SHIFTS_HOURLY_PAY_RATE = "urgent-shifts-hourly-pay-rate",
  ENABLE_NO_FACILITY_MAP_ALERT = "enable-no-facility-map-alert",
  ENABLE_BROWSING_SHIFTS_ACROSS_US_MAP_VIEW = "enable-browsing-shifts-across-us-map-view",
  FACILITY_DISTANCE_THRESHOLD_MAP_VIEW_CONFIG = "facility-distance-threshold-map-view-config",
  SIGN_UP_REFERRAL_SCREEN_EXPIRATION_DAY = "sign-up-referral-screen-expiration-days",
  DISABLE_UX_CAM = "disable-ux-cam",
  SHOW_ONBOARDING_AGENT_PROFILE_ERROR_MODAL = "show-onboarding-agent-profile-error-modal",
  HCP_CAN_EDIT_DATE_FOR_MULTI_DAY_SHIFTS = "hcp-can-edit-date-for-multi-day-shifts",
  SHOW_SHIFT_STATUS_FOOTER_INFO = "show-shift-status-footer-info",
  ENABLE_LUNCH_BREAK_INFO_POPUP = "enable-lunch-break-popup",
  MAX_REFERRAL_BONUS_CONFIG = "maximum-referral-bonus-config",
  ENABLE_WORKER_AVAILABILITY = "enable-worker-availability",
  WORKER_AVAILABILITY_CALENDER_CONFIG = "availability-calendar-button-config",
  HCP_LICENSE_NUMBER_REQUIREMENTS = "hcp-license-number-requirements",

  WORKPLACE_REFERRALS = "2023-10-facilitate-rollout-workplace-referrals",
  ENABLED_REFERRAL_PROGRAMS = "2023-10-sparta-enabled-referral-programs",
  SIGNUP_REFERRAL_BONUS_PAYMENT_ETA_IN_DAYS = "2023-12-sparta-signup-referral-bonus-payment-eta",
  ENABLED_SIGNUP_REFERRAL_GUARD_RAILS = "2023-12-sparta-enabled-sign-up-referral-guard-rails",
  WORKER_TO_WORKPLACE_AFFILIATE_EXPERIMENT = "2023-12-facilitate-experiment-worker-to-workplace-affiliate",
  MAX_DISTANCE_ALLOWED_FOR_LOCATION_VERIFICATION_IN_MILES = "2023-12-team-sparta-max-distance-allowed-for-location-verification-in-miles",
  SOLVE_UNPAID_BREAKS_ROLLOUT_STAGE_WITH_TARGETING = "2024-02-team-x-solve-worked-unpaid-breaks-rollout",
  OPEN_SHIFT_CALENDAR_V2_CELL_VARIANTS = "2024-02-frontend-force-open-shift-calendar-cell-variants",

  ROLLOUT_SHOW_CORRECT_ANSWERS_ON_QUIZ_SUBMISSION = "2024-02-action-rollout-show-correct-answers-on-quiz-submission",
  ROLLOUT_SHIFT_BLOCK_BOOKING = "2024-02-facilitate-rollout-block-shift-booking",
  HOME_HEALTH_BOOK_DIALOG_ATTENDANCE_ENABLED = "2024-04-home-health-hcp-book-dialog-attendance-enabled",
  UNDO_BOOKING_TIME_THRESHOLD = "2024-05-action-feature-undo-booking-time-threshold",
  UNDO_BOOKING_BUFFER_AFTER_BUTTON_CLICK_IN_SECONDS = "2024-07-action-feature-undo-booking-buffer-after-button-click-in-seconds",
  UNDO_BOOKING_LEAD_TIME_CONFIGURATION = "2024-09-action-feature-undo-booking-lead-time-configuration",
  ACTIVATION_REFERRAL_SHARE_MESSAGE_CONFIG = "2024-03-sparta-activation_referral_share_message_config",
  SHOW_DEBUG_PAGE_MENU_ITEM_IN_MY_ACCOUNT = "2024-05-team-action-show-debug-page-menu-item-in-my-account",
  CHECK_ALWAYS_ALLOW_LOCATION_SETTING = "2024-06-value-check-always-allows-location-setting",
  HOME_HEALTH_VISIT_REQUIREMENT_CHECK = "2024-06-home-health-visit-requirement-check",
  HYPERTRACK_CLOCK_IN_OUT = "2024-07-value-hypertrack-clock-in-out",
  TWILIO_VERIFICATION_API = "2024-08-sparta-rollout-twilio-verification-api",
  SHOW_DEBIT_CARD_EXPIRATION_BANNER = "2024-08-team-x-expiring-debit-card-banner",
  NEW_CLOCK_OUT_MODAL = "2024-08-team-x-clock-out-modal-rollout",
  BIOMETRIC_QUALITY_SIGNAL_EXPERIMENT = "2024-08-pricing-rollout-biometric-quality-signal-experiment",
  PEDOMETER_HISTOGRAM_CONFIG = "2025-03-invaluables-config-pedometer-histogram",
  GET_INSTANT_BOOK_SHIFTS_ENABLED = "2024-09-action-get-instant-book-shifts-enabled",
  NURSE_SHIFT_DOCUMENT_CHECK_FIX = "2024-10-team-action-handle-nurse-qualification-docs-check",
  ROLLOUT_QUIZ_WORKER_ON_NEGOTIATION = "2024-10-team-action-quiz-worker-on-negotiation",
  IN_APP_RATING_PROMPT = "2024-11-action-in-app-rating-prompt",
  ATTENDANCE_SCORE_INFO = "2024-11-attendance-score-info",
  CAREER_AGENT_CONFIG = "2024-11-sparta-career-agent-hcp-mobile-app-config",
  ROLLOUT_SKILLS_ASSESSMENT_DURING_ONBOARDING = "2025-01-action-rollout-skill-assessment-during-onboarding",
  SKILLS_ASSESSMENTS_CONFIG = "2024-11-action-configuration-skill-assessment",
  SCHEDULED_ASSESSMENTS_CONFIG = "2024-11-action-configuration-skill-assessment-scheduling",
  ROLLOUT_SCHEDULED_SKILL_ASSESSMENT = "2024-11-action-rollout-scheduled-skill-assessment",
  HELLOSIGN_INSTRUCTIONS_TEXT_ENABLED = "2024-11-alchemy-rollout-hello-sign-instructions-text",
  HYPER_TRACK_GEOTAG_EVENTS = "2024-12-alchemy-hyper-track-geotag-events",
  CLIPBOARD_SCORE_PRIORITY_ACCESS_SHIFTS_PER_WEEK = "2024-12-matrix-clipboard-score-priority-access-shifts-per-week",
  ROLLOUT_FEEDBACK_QUALITY_BONUS = "2025-01-invaluables-quality-bonus",
  PLACEMENT_CANDIDATE_RESUME_PARSING = "2024-11-placement-candidate-resume-parsing",
  APP_UPDATE_NUDGE = "2025-01-action-worker-app-update-nudge",
  CLIPBOARD_SCORE_LAUNCH_DATE = "2025-01-matrix-clipboard-score-launch-date",
  HIDE_HOUR_RESTRICTION_WARNING_IF_NO_CONFLICTS = "2025-01-27-invaluables-kill-switch-hide-hours-restrictions-if-no-conflicts",
  ROLLOUT_JOB_INTERVIEWS = "2025-01-27-facilitate-rollout-job-interviews",
  OS_LEVEL_PUSH_NOTIFICATIONS_SETTINGS = "2025-02-matrix-temp-os-level-push-notifications-settings",
  ACCOUNT_REVIEW_GUIDELINES = "2025-02-invaluables-config-account-review-guidelines",
  PLACEMENT_WORKER_TRIALS = "2025-03-03-facilitate-placement-worker-trials",
  ENABLE_SUPPORT_PAIRING = "2025-02-action-support-pairing",
  WORK_WITH_FRIENDS_V2 = "2025-03-action-work-with-friends-v2-toggle",
  MISSED_SHIFTS_CONFIGURATION = "2025-02-matrix-missed-shifts-configuration",
  WHITE_SCREEN_DETECTION = "2025-03-action-white-screen-detection",
  DISCARD_LATENESS_BOOKTIME_THRESHOLD = "2025-01-matrix-discard-lateness-booktime-threshold",
  BFF_CLOCK_IN_KILL_SWITCH = "2025-03-bff-clock-in-kill-switch",
  STRIPE_RETURN_LINK_FORCE_REDIRECT = "2025-04-01-facilitate-stripe-return-link-force-redirect", // temporary flag which should be removed soon
  GEOLOCATION_PREFETCH_FOR_BOOKING = "2025-04-matrix-booking-geolocation-configuration",
  HIDE_REVIEWS_UI_BY_FACILITY_ID = "2025-04-hide-reviews-ui-by-facility-id",
  HYPERTRACK_ALLOW_MOCK_LOCATION = "2025-04-15-hypertrack-allow-mock-location",
  WORKER_BADGES = "2025-04-hackathon-worker-badges",
  UNIFY_LATE_CANCELLATION_POLICY_AND_PAYOUT = "2025-04-unify-late-cancellation-policy-and-payout",
  SHIFT_SLOTS_V2_PAGE_SIZE = "2025-04-shift-slots-v2-page-size",
  WORKER_APP_INITIALIZATION_DEBUGGING = "2025-04-action-worker-app-initialization-debugging",
  GROWTH_WORKER_APP_DEBUGGING_REMOUNT_APP = "2025-06-growth-worker-app-debugging-remount-entire-react-tree",
  PAY_PREFERENCE_FILTER_SETTINGS = "2025-04-pricing-experiment-pay-preference-filter",
  ZENDESK_HC_ARTICLE_SSO = "2025-04-forge-zendesk-hc-article-sso",
  DYNAMIC_PENALTIES_CONFIG = "2025-04-dynamic-penalties-configuration",
  INCLUDE_WINDOWED_OUT_SHIFTS = "2025-04-matrix-show-unbookable-windowed-shifts",
  ENABLE_QR_CODE_DEEP_LINK = "2025-05-enable-qr-code-deep-link",
  REACTIVATION_BONUS_BANNER = "2025-05-12-riley-reactivation-bonus-banner",
  EDUCATE_FOR_FIRST_N_BOOKINGS = "2025-05-alchemy-educate-new-worker-confirmation-modal",
  BASKET_SIZE_LIMIT_CONFIGURATION = "2025-05-enable-basket-size-limit-configuration",
  SEE_PAST_SHIFTS_AND_PAPER_TIMESHEET = "2025-05-team-x-see-past-shifts-and-paper-timesheet",
  IN_APP_ADS = "2025-06-growth-in-app-ads",
  DISPLAY_INCIDENT_BANNER = "2025-06-growth-display-incident-banner",
  CUSTOM_QUALIFICATIONS = "2025-06-custom-qualifications-enabled",
  HCP_APP_ERROR_MESSAGES = "2025-06-facilitate-hcp-app-error-messages",
  HIRING_QUALIFICATION_RANKING = "2025-06-hiring-qualification-ranking",
  DEEP_LINKS_VIA_BACKEND_MAIN = "2025-06-rollout-deep-links-via-backend-main",
  DELAYED_WORKPLACE_REVIEW = "2025-12-delayed-workplace-review",
  CLOCK_IN_RULES_REMINDER_ENABLED = "2025-07-enable-clock-in-rules-reminder",
  NEWS_FEED_ENABLED = "2025-07-forge-news-feed-enabled",
  ENABLE_JOBS_MAP_VIEW_REDIRECTION = "2025-07-facilitate-enable-jobs-map-view-redirection",
  TRAVEL_PAGE_ROLLOUT = "2025-07-travel-page-rollout",
  CANCELLATION_STATS = "2025-04-hackathon-cancellation-stats",
  ENABLE_FAVORITE_WORKPLACES = "2025-07-enable-favorite-workplaces",
  FORTUNE_COOKIE_ANIMATION = "2025-11-orbit-fortune-cookie-animation",
  SHIFT_BOOST_CONFIG = "2025-07-config-shift-boost",
  HACKATHON_TIMECLOCK_DIRECTIONS = "2025-07-hackathon-timeclock-directions",
  HACK_WEEK_SHIFT_RECOMMENDATIONS = "2025-07-hack-week-shift-recommendations",
  USE_HELLOSIGN_FALLBACK_URL = "2025-07-alchemy-config-use-hellosign-fallback-static-url",
  TRACK_INDEXEDDB_SPLASH_HANG = "2025-07-rollout-track-indexeddb-splash-hang",
  CLIPBOARD_SCORE_REDESIGN = "2025-07-clipboard-score-redesign",
  DOCUMENT_EXCLUSION_LIST = "2025-08-hide-documents-from-documents-page",
  SHIFT_DISCOVERY_DETECT_STAGE_CHANGES = "2025-08-shift-discovery-detect-stage-changes",
  SHIFT_TRANSFER_ENABLED = "2025-07-orbit-mobile-shift-transfer-enable",
  QUALIFICATION_CATEGORIES_CONFIG = "2025-08-alchemy-config-qualification-categories",
  PLACEMENTS_QUALIFICATION_FILTER = "2025-08-hire-professionals-qualification-filter",
  HIRING_INCENTIVE_PROGRAM = "2025-08-hiring-reliability-incentive",
  WORKER_TO_WORKER_REFERRAL_TYPE = "2025-08-configure-worker-to-worker-referral-type",
  SHIFT_DISCOVERY_FILTERS_REDESIGN = "2025-08-shift-discovery-combined-filtering-experience",
  PLACEMENT_RECRUITER_SCREENING = "2025-08-placements-recruiter-screening",
  CONFIG_DOCUMENT_UPLOAD_MULTI_SELECT = "2025-08-config-document-upload-multi-select",
  ARRIVAL_TIME_CONFIGURATION = "2025-08-alchemy-arrival-time-configuration",
  INDEPENDENT_CONTRACTOR_BADGE_REVAMP = "2025-08-independent-contractor-badge-revamp",
  RECRUITER_SCREENING_CALL_NOW_HOURS = "2025-08-placements-recruiter-screening-call-now-hours",
  PREFERRED_PERSISTENCE_FOR_AUTH = "2025-08-preferred-persistence-for-auth",
  LICENSE_RECIPROCITY = "2025-08-license-reciprocity",
  MAXIMIZE_BRIGHTNESS_ON_TOUCHPOINT_QR_DISPLAY_STEP = "2025-09-maximize-brightness-on-touchpoint-qr-display-step",
  ENFORCE_NFC_TIMESHEET_BOUNDS = "2025-09-team-forge-enforce-nfc-timesheet-bounds",
  TIMELINESS_BONUS_REDESIGN_CONFIG = "2025-10-aps-timeliness-redesign",
  SURFACE_JOBS = "2025-10-surface-jobs",
  SHIFT_DISCOVERY_DAYS_TO_FETCH = "2025-10-orbit-shift-discovery-days-to-fetch",
  CONFIGURE_SSN_REQUIRED_STATES = "2025-10-configure-ssn-required-states",
  ENABLE_COGNITO_AUTH_SYNC = "2025-10-enable-cognito-auth-sync",
  ENABLE_COGNITO_ONBOARDING = "2025-10-enable-cognito-onboarding",
  ENABLE_COGNITO_IN_API_CALLS = "2025-10-enable-cognito-in-api-calls",
  ENABLE_COGNITO_PHONE_LOGIN = "2026-02-enable-cognito-phone-login",
  JOBS_NEW_MARKET_LAUNCH = "2025-10-gaia-jobs-new-market-launch",
  CONTRACTOR_AGREEMENT_RE_SIGNING = "2025-10-contractor-agreement-re-signing",
  ARRIVAL_TIME_FLOW_WORKPLACE_EXCLUSIONS_CONFIG = "2025-10-alchemy-config-arrival-time-flow-exclusion",
  ENABLE_NEW_PAYOUT_SETTINGS = "2025-10-enable-new-payout-settings",
  ENABLE_FAILED_PAYOUT_BANNER = "2025-11-enable-failed-payout-banner",
  ENABLE_NEW_EARNINGS_PAGE = "2025-11-enable-new-earnings-page",
  RUN_BACKGROUND_CHECK_ON_BOOKING = "2025-10-run-background-check-on-booking",
  CONFIGURE_LOGIN_SIGNUP_UI = "2025-10-configure-login-signup-ui",
  ENABLE_CHILDCARE_SUPPORT_CHAT = "2025-10-enable-childcare-support-chat",
  ROLLOUT_DETECTED_CHARTING_CREDENTIALS = "2025-10-rollout-detected-charting-credentials",
  ENABLE_VIDEO_POSTING = "2025-11-hackathon-video-posting",
  HIRING_INSTANT_PAY = "2025-11-instantpay-hiring",
  FORM_1099_UI = "2025-11-1099-form-ui",
  SHOW_RENEW_LICENSE_INSTRUCTIONS = "2025-11-show-renew-instructions",
  LIVE_ACTIVITIES_CONFIG = "2025-10-alchemy-rollout-live-activities",
  CREDENTIAL_REQUIREMENTS_CONFIGURATION = "2025-12-configure-credential-requirements",
  WORKER_ETA_IMPROVEMENTS = "2025-12-release-worker-eta-improvements",
  HOLIDAY_GIFT = "2025-12-figs-sweater-reward-1000-clipboard-score",
  SENDBIRD_PAGE_SIZE = "2025-12-configure-sendbird-page-size",
  PLACEMENT_BOOKING_FLOW_ORDER = "2025-12-placement-booking-flow-order",
  EMERGENCY_CREDITS_CONFIG = "2025-12-emergency-credits-config",
  AUTO_CLOCKOUT_SHIFT_END_THRESHOLD = "auto-clockout-shift-end-threshold",
  TIMECLOCK_INFO_WHEN_CONTACTING_SUPPORT = "2025-18-orbit-timeclock-info-when-contacting-support",
  ENABLE_SUBMIT_HIRING_DOCUMENTS_LATER = "2025-12-enable-submit-hiring-documents-later",
  ROLLOUT_FILTER_BACKGROUND_CHECK_REQUIREMENTS_V2 = "2025-12-rollout-filter-background-check-requirements-v2",
  JOB_SEARCH_AGREEMENT_ENABLED = "2026-01-gaia-job-search-agreement-enabled",
  SIGNUP_JOB_SEARCH_AGREEMENT_CONFIG = "2026-01-gaia-signup-job-search-agreement-config",
  RELEASE_WORKER_WORK_BADGES_MAX_UI = "2026-01-release-worker-work-badges-max-ui",
  INTERACTIVE_SUPPORT_ENABLED = "2026-01-interactive-support-enable",
  WORKER_PAY_SURVEY_CONFIG = "2026-01-configure-worker-pay-survey",
  ATTENDANCE_TRACKING_METHODS_ROLLOUT = "2026-01-attendance-tracking-methods-rollout",
  ENABLE_PAYMENT_DETAILS_PAGE = "2026-01-enable-payment-details-page",
  ENABLE_BADGE_VERIFICATION_CLOCK_IN = "2026-01-enable-badge-verification-clock-in",
  WORKER_FORCED_CANCELLATION_CHAT_WARNING = "worker-forced-cancellation-chat-warning",
  ENABLE_CONNECTED_JOB_LISTINGS = "2026-01-enable-worker-connected-job-listings",
  EARLY_ACCESS_FACILITIES = "2025-01-early-access-facilities",
  CONFIGURE_WORK_BADGE_SETTINGS = "2026-02-configure-work-badge-settings",
  CHAT_CANCELLATION_DETECTION = "2026-02-enable-chat-cancellation-detection",
  GUARANTEED_PAY_WAITLIST = "2026-02-release-guaranteed-pay-waitlist",
  ENABLE_STRIPE_RESTRICTION_BANNER = "2026-02-enable-stripe-restriction-banner",
  ALCHEMY_CLIPBOARD_GUIDES_EXPERIMENT = "2026-02-alchemy-clipboard-guides-experiment",
  CONCORDE_SCHOLARSHIP = "2026-02-release-concorde-scholarship",
  TRAVEL_SHIFTS = "2026-02-release-travel-shifts",
  SHIFT_BUNDLES = "2026-02-config-worker-shift-bundles",
  ENABLE_NEW_STRIPE_ONBOARDING = "2026-02-enable-new-stripe-onboarding",
  ENABLE_SHIFT_HISTORY_PAGE_REDESIGN = "2026-02-enable-shift-history-page-redesign",
}
